/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-03-22 14:31:51
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-01-06 15:02:00
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\Organization\api\medicalinfo.js
 */
//引入接口文档
import req from '@/utils/req.js'

//医院查询
export function api_hospital(params ={}) {
  return req.post('/admin/hospital/list', params)
}

//科室查询
export function api_department(params) {
  return req.post('/admin/open-department/list', params)
}

//获取职称接口
export function api_doctor_title() {
  return req.get('/admin/category/doctor_title/children')
}
export function inquiry_config_detailByRefId(params) {
  return req.get('/admin/inquiry-config/detailByRefId',params)
}

export function inquiry_config(params) {
  return req.put('/admin/inquiry-config',params)
}
export function inquiry_config_post(params) {
  return req.post('/admin/inquiry-config',params)
}

export function setAsStar(params) {
  return req.put(`/admin/doctor/setAsStar/${params.doctorId}/${params.value}`)
}
export function setHospitalAsStar(params) {
  return req.put(`/admin/doctor/setRecommendInHospital/${params.doctorId}/${params.value}`)
}
export function doctorNurseCreate(params) {
  return req.post('/admin/user/create/doctor', params)
}

export function getListByHospitalId(params) {
  return req.get('/admin/doctor-team/getListByHospitalId',params)
}
